// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CVJ7H","card":"styles_card__Mw1Y2"};